/* @flow */
import * as React from 'react';

import BlockedUser from 'entities/BlockedUser';
import Button from 'components/Button';
import MediaObject from 'components/MediaObject';
import RelationshipActions from 'actions/RelationshipActions';
import Text from 'components/Text';
import Time from 'components/Time';
import UserAvatar from 'users/components/UserAvatar';

export default class BlockedUsersListItem extends React.Component<{
  blockedUser: BlockedUser,
}> {
  unblockUser(): void {
    const { blockedUser } = this.props;
    const { id } = blockedUser;
    const name = blockedUser.getName();
    RelationshipActions.unblock(id, name);
  }

  render() {
    const { blockedUser } = this.props;

    return (
      <tr className="BlockedUsersListItem">
        <td>
          <Text className="BlockedUsersListItem-userName" truncate>
            <MediaObject center>
              <UserAvatar user={blockedUser.toJSON()} size="medium" />
              {blockedUser.getName()}
            </MediaObject>
          </Text>
        </td>
        <td>
          <Time date={blockedUser.getBlockedAt()} month="short" day="numeric" />
        </td>
        <td>
          <Button level="secondary" size="small" onClick={() => this.unblockUser()}>
            Unblock
          </Button>
        </td>
      </tr>
    );
  }
}
